import {useTranslation} from "react-i18next";
import {useMemo} from "react";
import {yup} from "./index";


export const useModel1Schema = () => {
    const {t} = useTranslation('validation');

    const number = yup.number().nullable().typeError(t('validation:number'))
    const positiveNumber = number.min(0, t('validation:gte', {gte: 0}));
    const positiveInteger = positiveNumber.integer(t('validation:integer'));
    const temperature = number.lessThan(50, t('validation:lt', {lt: 50}))

    return useMemo(
        () => (
            yup.object().shape({
                station: yup.object().required(t('validation:required')),
                datetime: yup.date().required(t('validation:required')).typeError(t('validation:invalidDate')),
                hs: positiveInteger,
                hn: positiveInteger,
                ps: positiveNumber,
                th10: temperature,
                th30: temperature,
                pr: positiveInteger,
                ta: temperature,
                tMin: temperature,
                tMax: temperature,
                hnStim: positiveNumber,
                hnCum: positiveInteger,
            })
        ),
        [t]
    );
}